/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'

/**
 * Typescript enum
 */

export enum TournamentDifficulty {
  ADVANCED = 'ADVANCED',
  ALL = 'ALL',
  BEGINNER = 'BEGINNER',
  GENERAL = 'GENERAL'
}

/**
 * TournamentDifficulty
 *
 * The different difficulty levels of a tournament
 */
export const TournamentDifficultyEnumType = types.enumeration('TournamentDifficulty', [
  'ADVANCED',
  'ALL',
  'BEGINNER',
  'GENERAL'
])
